import "core-js/modules/es.promise.js";
import { uniCall, prepareApi } from '../../utils';
prepareApi(['bcz_system']);
/**
 * 设置是否拦截导航栏回退按钮点击操作（默认不拦截）
 * - `false` - 不拦截
 * - `() => void` - 拦截，点击回退按钮时执行传入的回调函数
 */

export function interceptNavBack(opt) {
  return new Promise(function (resolve) {
    if (typeof opt === 'function') {
      window.bcz_system.onInterceptNavBack = opt;
    } else {
      delete window.bcz_system.onInterceptNavBack;
    }

    var param = {
      enabled: Boolean(opt)
    };
    uniCall({
      api: 'interceptNavBack',
      param: param
    });
    resolve();
  });
}